import { makeStyles, Theme } from '@material-ui/core'
import { ChipProps } from './ChipProps'

const getBackground = (theme: Theme) => (props: ChipProps) => {
  const { variant, severity } = props
  let background = theme.palette.grey[100]
  const backgrounds = {
    outlined: 'none',
    error: 'error.main',
    warning: 'warning.main',
    info: 'info.light',
    success: 'success.light',
  }
  if (variant === 'outlined') {
    background = backgrounds[variant]
  } else if (severity) {
    const [color, colorVariant] = backgrounds[severity].split('.')
    // @ts-expect-error - todo.
    background = theme.palette[color][colorVariant]
  }
  return background
}

const getColor = (theme: Theme) => (props: ChipProps) => {
  const { variant, severity } = props
  let textColor
  if (variant === 'outlined' && severity) {
    const textColors = {
      error: theme.palette.error.main,
      info: theme.palette.info.main,
      warning: theme.palette.warning.dark,
      success: theme.palette.success.dark,
    }
    textColor = textColors[severity]
  } else if (variant === 'outlined' && !severity) {
    textColor = theme.palette.grey[700]
  } else if ((variant === 'default' || variant === undefined) && severity) {
    const textColors = {
      error: theme.palette.common.white,
      info: theme.palette.secondary.main,
      warning: theme.palette.secondary.main,
      success: theme.palette.secondary.main,
    }
    textColor = textColors[severity]
  }
  return textColor
}

const getBorder = (theme: Theme) => (props: ChipProps) => {
  const { variant, severity } = props
  let borderColor
  if (variant === 'outlined' && severity) {
    const borderColors = {
      error: theme.palette.error.main,
      info: theme.palette.info.main,
      warning: theme.palette.warning.dark,
      success: theme.palette.success.dark,
    }
    borderColor = borderColors[severity]
  }
  return borderColor
}

// using `any` here is a bit of cheating but it doesn't matter since this doesn't depend on
// any component-specific props
export const useChipStyles = makeStyles<Theme, ChipProps<any>>((theme) => ({
  root: {
    background: getBackground(theme),
    color: getColor(theme),
    borderColor: getBorder(theme),
    borderRadius: theme.spacing(0.5),
  },
  icon: {
    color: 'inherit',
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
  deleteIcon: {
    color: theme.palette.grey[500],
  },
}))
